import React, { useEffect, useState } from "react";
import { Button, Table2, Label } from "components";
import { Edit, Trash, Cross, Check } from "../../../../../../layouts/dashboard/sidebar/icons/icons/icons";
import config from "constants/config";
import useTheme from "../../../../../../../../hooks/useTheme";

import "../modals.scss";

const CUSTOM_FIELD = {
	name: '',
	type: config.CUSTOM_TYPE[0],
	placeholder: '',
	default: '',
	regex: '',
	required: false
}

const PlusIcon = () => <svg width="20px" height="20px" viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
	<path d="M10 4.16667V15.8333" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
	<path d="M4.16675 10H15.8334" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
</svg>;

const MinusIcon = () => <svg width="20px" height="20px" viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
	<path d="M4.16675 10H15.8334" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
</svg>;

export const CustomTable = ({ data, edit, remove, skipButtons }) => {

	if(skipButtons && !data.length) {
		return null
	}

	let columns = [{
		accessor: 'name',
		Header: 'Name'
	}, {
		accessor: 'type',
		Header: 'Type',
		Cell: ({ row }) => (
			<div className="badge badge-confirmation">
				{row.original.type ? (row.original.type.label ? row.original.type.label : row.original.type) : "Number"}
			</div>
		),
	}, {
		accessor: 'placeholder',
		Header: 'Placeholder'
	}, {
		accessor: 'default',
		Header: 'Default Value'
	}, {
		accessor: 'regex',
		Header: 'Regex',
	}, {
		accessor: 'required',
		Header: 'Required',
		Cell: ({ row }) => +row.original.required ? <Check /> : <Cross />,
	}, {
		accessor: 'options',
		Header: '',
		disableSortBy: true,
		Cell: ({ row }) => (
			<div className="widget-table-options">
				<Button onClick={() => edit(row.index)} size="large" square variant="secondary" className="mr-3">
					<Edit />
				</Button>
				<Button onClick={() => remove(row.index)} size="large" square variant="warning">
					<Trash />
				</Button>
			</div>
		)
	}];


	if(skipButtons) {
		columns.pop()
	}

	if(!data.length) {
		return null
	}

	return <div className="widget-modal-table">
		<Table2 data={data} columns={columns} notFound="No custom fields" />
	</div>
};


const CustomForm = ({ data, setData, cancel, update, active }) => {

	if(!active) {
		return null
	}

	const isSelect = data.type === "select";
	const isCheckbox = data.type === "checkbox";
	const isHidden = data.type === "hidden";

	return <div className="custom-widget">

		<div className="custom-widget-body flex-wrap">

			<div className="mb-3 w-100">
				<label className="paylixecommerce-label" htmlFor="type" >Field Type</label>
				<select value={data.type} className="paylixecommerce-select" onChange={(e) => setData({ ...data, type: e.target.value })}>
					{config.CUSTOM_TYPE.map(({ value, label }) => <option key={value} value={value}>{label}</option>)}
				</select>
			</div>

			<div className="mb-3 w-100">
				<label className="paylixecommerce-label" htmlFor="name" >Field Name</label>
				<input className="paylixecommerce-input" type="text" value={data.name} placeholder="Custom field name"
				       onChange={(e) => setData({
					       ...data,
					       name: e.target.value
				       })}
				/>
			</div>

			{(isCheckbox || isHidden || isSelect) ? null :
				<div className="mb-3 w-100">
					<label className="paylixecommerce-label" htmlFor="regex" >Regex</label>
					<input className="paylixecommerce-input" type="text" value={data.regex} placeholder="Regex required to be met"
					       onChange={(e) => setData({
						       ...data,
						       regex: e.target.value
					       })}
					/>
				</div>
			}

			{(isCheckbox || isHidden) ? null :
				<div className="mb-3 w-100">
					<label className="paylixecommerce-label" htmlFor="placeholder">Placeholder</label>
					<input className="paylixecommerce-input" type="text" value={data.placeholder} placeholder="Placeholder"
					       onChange={(e) => setData({
						       ...data,
						       placeholder: e.target.value
					       })}
					/>
				</div>
			}

			{(isCheckbox || isSelect) ? null :
				<div className="mb-3 w-100">
					<label className="paylixecommerce-label" htmlFor="default" >Default Value</label>
					<input className="paylixecommerce-input" type="text" placeholder="Default value" value={data.default}
					       onChange={(e) => setData({
								...data,
								default: e.target.value
							})}
					/>
				</div>
			}

			{isSelect ?
				<div className="mb-3 w-100 is-select">
					<label htmlFor="req" className="paylixecommerce-label">
						Values
					</label>

					{
						(data.values || []).map((value, key) => {
							return <div className="d-flex mb-2">
								<div className="w-100">
									<input className="paylixecommerce-input" type="text" value={value} placeholder="Custom field name"
										   onChange={(e) => {
											   data.values[key] = e.target.value;
											   setData({
												   ...data,
												   values: [...data.values]
											   })
										   }}
									/>
								</div>
								<div>
									<Button size="large" square variant="warning" className="ml-2" onClick={() => {
										delete data.values[key];
										setData({
											...data,
											values: [...data.values]
										})
									}}>
										<MinusIcon />
									</Button>
								</div>
							</div>
						})
					}

					<Button size="medium" square variant="primary" className="w-100" onClick={() => {
						setData({
							...data,
							values: data.values ? [...data.values, ""] : [""]
						})
					}}>
						<PlusIcon />
					</Button>
				</div>
			: null}

			{isSelect && data.values ?
				<div className="mb-3 w-100">
					<label className="paylixecommerce-label" htmlFor="default" >Default Value</label>
					<select className="paylixecommerce-select" name="" value={data.default} onChange={(e) => setData({
						...data,
						default: e.target.value
					})}>
						{data.values.map(value => <option key={value} value={value}>{value}</option>)}
					</select>
				</div>
			: null}



			{isHidden ? null :
				<div className="switcher-container w-100 d-flex flex-nowrap flex-row-reverse align-items-center justify-content-center">
					<label htmlFor="req" className="switcher-label">
						<div className="paylixecommerce-label mb-0">Required</div>
					</label>
					<label className="switcher ml-0 mr-3">
						<input type="checkbox" id="req" name="req" checked={data.required} onChange={(e) => setData({ ...data, required: e.target.checked })} />
						<span className="switcher-slider" />
					</label>
				</div>
			}

		</div>

		<div className="custom-widget-footer">
			<Button className="mr-3" size="large" variant="secondary" onClick={cancel}>
				Cancel
			</Button>
			<Button size="large" disabled={data.name ? "" : "disabled"} onClick={() => {if(data.name) {update()} else {}}}>
				Save
			</Button>
		</div>

	</div>
}


export default ({ setModal, modal, fields, updateFields, skipButtons }) => {

	const [currentIndex, setCurrentIndex] = useState(null);
	const [data, setData] = useState({});
	const isDark = useTheme();

	useEffect(() => {
		if(currentIndex === 0 || currentIndex) {
			let field = fields[currentIndex] ? fields[currentIndex] : CUSTOM_FIELD;
			setData({
				type: field.type && (field.type.value ? field.type.value : field.type),
				name: field.name,
				regex: field.regex,
				placeholder: field.placeholder,
				default: field.default,
				required: field.required,
				values: field.values
			});
		}
	}, [currentIndex]);


	const addField = (index) => {
		setCurrentIndex(index ? index : true);
	};

	const updateField = () => {

		if(fields[currentIndex]) {
			fields[currentIndex] = data;
			updateFields([
				...fields
			]);
		} else {
			updateFields([
				...fields,
				data
			]);
		}

		setCurrentIndex(null);
		setModal(null);
	}

	const cancelEdit = () => {
		setCurrentIndex(null);
		setModal(null);
	}

	const editField = (index) => {
		setCurrentIndex(index);
		setModal(fields[index]);
	}

	const removeField = (index) => {

		if(fields[index]) {

			let updated = Object.assign([], fields);
			updated.splice(index, 1);
			updateFields([
				...updated
			]);

		}

		setCurrentIndex(null);
	}

	const active = (currentIndex === 0 || currentIndex);

	return <div className="widget-modal">

		{skipButtons ? null : <Label label="Custom Fields" tooltip="Ask your customer additional information and input fields at the moment of purchase" name="custom" />}

		<CustomTable data={fields} edit={editField} remove={removeField} />

		{modal ? <CustomForm update={updateField} cancel={cancelEdit} setData={setData} data={data} active={modal} /> : <Button onClick={() => setModal(true)} className="w-100" size="large" variant={isDark ? "primary" : "secondary"} iconName="plus" iconPosition="left" >Custom Fields</Button>}
	</div>
}
